import { Check } from "lucide-react";
import { useBrand } from "../../context/brand";

export const PriceCard = () => {
  const { perks, priceImg } = useBrand();
  return (
  <div className="lz-price" data-testid="price-card">
    {priceImg && <img src={priceImg} alt="" className="lz-price-img" />}
    <div className="relative p-4">
      <span className="lz-chip lz-chip-dark">Plano mensal</span>
      <p className="lz-price-value" data-testid="price-value">
        <small>R$</small>25<small>,00</small><em>/mês</em>
      </p>
      <ul className="space-y-2 mt-3">
        {perks.map((p) => (
          <li key={p} className="flex gap-2 text-[13.5px] leading-snug text-[#E8EFE9]">
            <Check size={16} className="shrink-0 mt-0.5 text-[#D4FF3A]" /> {p}
          </li>
        ))}
      </ul>
    </div>
  </div>
  );
};
